module.exports = __webpack_public_path__ + "dash_20_app_assets/img/fs.ffd65183.png";